<template>
  <div>
    <Header headerText="Welcome! "></Header>
    <div class="blurb-container w3-rest">
      <h1 class="blurb-title">Quick bit about me</h1>
      <div class="blurb-decoration-bar"></div>
      <div>
        <div class="blurb-content">
          <h4>I am a Pittsburgh native currently in Philadelphia with a passion for tech, building new things, and teaching my daughter everything I can. I received my bachelor's degree in Information Science and a certificate in Russian and Eastern European studies from the University of Pittsburgh.</h4>
          <div class="w3-half w3-padding">
            <h4>[Short list of my favorite things]</h4>
            <ul class="w3-ul w3-hoverable">
              <li>CI/CD pipelines</li>
              <li>Docker and Kubernetes</li>
              <li>System automation</li>
              <li>Anything linux (Ubuntu/Debian/Redhat) in no particular order</li>
              <li>GCP and Digital Ocean, though AWS is ok too!</li>
              <li>Python and Bash scripting</li>
              <li>3d modeling and 3d printing</li>
              <li>Some front end development, like this site!</li>
            </ul>
          </div>
          <div class="w3-half w3-padding">
            <h4>[Photo of myself with some of my really favorite things]</h4>
            <img class="w3-card-4" src="../assets/sam.jpg" style="max-height:20em; max-width: 100%">
          </div>
        </div>
      </div>
    </div>

    <div class="blurb-container">
      <h1 class="blurb-title">Contact</h1>
      <div class="blurb-decoration-bar"></div>
      <div>
        <p class="blurb-content">If you would like to get in contact with me to talk about 3d printer slicers, custom node exporter metrics, innovative CI/CD pipelines, or future opportunities, please connect with me on <a class="text-highlight" href="https://www.linkedin.com/in/sam-depretis-1a4474b1/">LinkedIn</a></p>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'

export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>
<style>
.text-highlight {
    font-weight: bold;
}
</style>